// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {bisnisUnitSelector, getBisnisUnit, insertBisnisUnit, updateBisnisUnit} from './bisnisUnitSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const BisnisUnitPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const bisnisUnit = useSelector(
        bisnisUnitSelector
    );

    useEffect(() => {
        dispatch(getBisnisUnit({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && bisnisUnit.isGetSuccess && !bisnisUnit.isGetFetching) {
            let calc = bisnisUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bisnisUnit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && bisnisUnit.isGetSuccess && !bisnisUnit.isGetFetching) {
            let calc = bisnisUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bisnisUnit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!bisnisUnit?.isGetFetching && bisnisUnit.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = bisnisUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bisnisUnit.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getBisnisUnit({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (bisnisUnit.isGetSuccess) {
                alertService.success(bisnisUnit.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getBisnisUnit({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (bisnisUnit.isUpdateSuccess) {
                alertService.success(bisnisUnit.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateBisnisUnit({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetBisnisUnit(params) {
    //   return dispatch(getBisnisUnit(params));
    // }

    function handleInsertBisnisUnit(param) {
        setInsertFetch(true);
        const params = {
            namaBisnisUnit: param.inputOneValue,
            bisnisUnitID: param.dropdownOneValue,
        };
        dispatch(insertBisnisUnit(params));
    }

    function handleUpdateBisnisUnit(param) {
        setUpdateFetch(true);

        const params = {
            namaBisnisUnit: param.inputOneValue,
            idBisnisUnit: currentData.BisnisUnitID,
            status: param.status,
        };
        dispatch(updateBisnisUnit(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getBisnisUnit(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getBisnisUnit(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (bisnisUnit.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? bisnisUnit.count : newCount,
            search: search,
        }
        dispatch(getBisnisUnit(params));

        setPage(1);
        setCount((newCount === "-1") ? bisnisUnit.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Bisnis Unit"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Bisnis Unit"
                                tableData={bisnisUnit.data}
                                colOneTitle="ID"
                                colOneData="BisnisUnitID"
                                colTwoTitle="Kode Bisnis Unit"
                                colTwoData="KodeBisnisUnit"
                                colThreeTitle="Nama Bisnis Unit"
                                colThreeData="NamaBisnisUnit"
                                status="Status"

                                fetching={bisnisUnit.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Bisnis Unit"
                        inputOneTitle="Nama Bisnis Unit"
                        inputOnePlaceholder=""
                        inputTwoTitle="Kode Bisnis Unit"
                        inputTwoPlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertBisnisUnit}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.BisnisUnitID}
                        modal={handleModal}
                        modalTitle="Ubah Bisnis Unit"
                        inputOneTitle="Nama BisnisUnit"
                        inputOneValue={currentData.NamaBisnisUnit}
                        inputTwoTitle="Kode Bisnis Unit"
                        inputTwoValue={currentData.KodeBisnisUnit}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateBisnisUnit}
                    />
                }
            </div>

        )
    }

}


export default BisnisUnitPage;